declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let pixelInitialized = false

export function initMetaPixel() {
  if (pixelInitialized) return
  pixelInitialized = true

  // Initialize fbq function before script loads
  if (!window.fbq) {
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = [] as any[]
    window.fbq = fbq
    window._fbq = fbq
  }

  // Load the Facebook pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1394051825269084&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  // Init and track PageView
  window.fbq('init', '1394051825269084')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Método Express Alteraciones',
        content_type: 'product',
        value: 17.27,
        currency: 'USD',
      })
    }
  } catch (e) {
    // Silently fail — don't block navigation
  }
}
